import { MarketingLanguageType } from "@/types/graphql/partner.generated";

/** Языки писем витрины в порядке меню «+» у вкладок вариантов. */
export const MARKETING_LANGUAGES: MarketingLanguageType[] = [
  MarketingLanguageType.RuType,
  MarketingLanguageType.EnType,
  MarketingLanguageType.PlType,
  MarketingLanguageType.PtType,
];

export const LANGUAGE_LABEL_KEYS: Record<MarketingLanguageType, string> = {
  [MarketingLanguageType.RuType]: "emailTemplates.languages.ru",
  [MarketingLanguageType.EnType]: "emailTemplates.languages.en",
  [MarketingLanguageType.PlType]: "emailTemplates.languages.pl",
  [MarketingLanguageType.PtType]: "emailTemplates.languages.pt",
};
